module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/en-技术研发.b9b404df.png";